<nz-form-item class="pf-form-item">
    @if (!!label) {
        <nz-form-label
            class="pf-form-label"
            [nzRequired]="pfRequired"
            [nzNoColon]="true"
            [title]="label"
            [nzTooltipTitle]="tooltip"
            [nzFor]="label"
        >{{ label }}
        </nz-form-label>
    }
    <ng-template #tooltipIcon>
        <pf-icon iconType="info"></pf-icon>
    </ng-template>
    <nz-form-control
        [nzAutoTips]="autoTips"
        nzHasFeedback
        class="pf-form-control"
        [nzErrorTip]="pfErrorTip">
        @switch (typeProps?.componentType) {
            @case ("inputNumber") {
                <span class="pf-number-input-container">
                    <ng-container
                        *ngTemplateOutlet="inputPrefixTpl"></ng-container>
                    <nz-input-number
                        class="pf-input"
                        #inputNumber
                        [attr.name]="label || null"
                        [formControl]="formControl"
                        label="input-label"
                        [nzMax]="typeProps?.max | safeNumber: 'infinity'"
                        [nzMin]="
                            typeProps?.min | safeNumber: 'negativeInfinity'
                        "
                        [nzParser]="parseNumber"
                        [nzKeyboard]="true"
                        [nzPlaceHolder]="placeholder"
                        (input)="search($event)"
                        (nzOnStep)="pfInput.emit($event.value)"
                        (touchstart)="inputTouched()"
                        (mousedown)="inputTouched()"></nz-input-number>
                    <ng-container
                        *ngTemplateOutlet="iconSuffixTpl"></ng-container>
                </span>
            }
            @case ("textarea") {
                <nz-textarea-count
                    [nzMaxCharacterCount]="
                        typeProps?.maxLength | safeNumber: 'none'
                    ">
                    <textarea
                        [rows]="textAreaRows"
                        nz-input
                        class="pf-input"
                        [attr.name]="label || null"
                        [formControl]="formControl"
                        [placeholder]="placeholder"
                        [attr.minLength]="typeProps?.minLength"
                        [attr.maxLength]="typeProps?.maxLength"
                        (input)="pfInput.emit($event)"
                        (touchstart)="inputTouched()"
                        (mousedown)="inputTouched()"></textarea>
                </nz-textarea-count>
            }
            @default {
                <nz-input-group
                    [nzPrefix]="inputPrefixTpl"
                    [nzSuffix]="iconSuffixTpl">
                    <input
                        class="pf-input"
                        nz-input
                        #input
                        [attr.name]="label || null"
                        [formControl]="formControl"
                        [attr.type]="typeProps?.type"
                        [attr.placeholder]="placeholder"
                        [attr.minLength]="typeProps?.minLength || null"
                        [attr.maxLength]="typeProps?.maxLength || null"
                        [attr.inputMode]="typeProps?.inputMode || null"
                        (input)="search($event)"
                        (ngModelChange)="onChange($event)"
                        [nzAutocomplete]="autoCompleteList"
                        (touchstart)="inputTouched()"
                        (mousedown)="inputTouched()" />
                    <nz-autocomplete #autoCompleteList>
                        @for (option of filteredDataList; track option) {
                            <nz-auto-option [nzValue]="option"
                            >{{ option }}
                            </nz-auto-option>
                        }
                    </nz-autocomplete>
                </nz-input-group>
            }
        }
    </nz-form-control>
</nz-form-item>
<ng-template #inputPrefixTpl>
    @if (inputPrefix) {
        <span class="pf-input-prefix">{{ inputPrefix }}</span>
    }
</ng-template>
<ng-template #iconSuffixTpl>
    @if (inputSuffix) {
        <span class="pf-input-suffix">{{ inputSuffix }}</span>
    }
    @if (typeProps?.suffixIcon) {
        <pf-icon [iconType]="typeProps!.suffixIcon!"></pf-icon>
    }
</ng-template>
